import { CAT_AI_NEWS } from 'App/utils/Collections';
import { FT_AUTOCOMPLETE, FT_LIST, FT_DATE } from '../FilterTypes';
import { searchAINewsDomains, searchAINewsTags, loadCategories, loadAINewPrompts } from './loaders';
import { ROLE_STAFF } from '@/app/constants/Roles';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
};

export default {
  category: CAT_AI_NEWS,
  filters: [
    {
      id: 'published_on',
      type: FT_DATE,
      label: 'Published on',
      group: groups.date,
    },
    {
      id: 'domain_id',
      label: 'Domain',
      group: groups.general,
      type: FT_AUTOCOMPLETE,
      placeholder: 'Choose domain',
      fieldConf: {
        deletebleChips: true,
        chips: true,
        searcher: searchAINewsDomains,
      },
    },
    {
      id: 'tag_id',
      label: 'Tags',
      group: groups.general,
      type: FT_LIST,
      placeholder: 'Choose tags',
      roles: [ROLE_STAFF],
      getListItems: searchAINewsTags,
    },
    {
      id: 'category_id',
      label: 'Categories',
      group: groups.general,
      type: FT_LIST,
      placeholder: 'Choose categories',
      roles: [ROLE_STAFF],
      multiValues: false,
      getListItems: loadCategories,
    },
    {
      id: 'prompt_id',
      label: 'Prompts',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: (term, filters = {}) => loadAINewPrompts({ complex_name: term, ...filters }),
        slug: 'ai-news-prompts',
        filter: () => true,
      },
    },
    {
      id: 'status',
      label: 'Status',
      group: groups.general,
      type: FT_LIST,
      placeholder: 'Choose status',
      multiValues: false,
      getListItems: () => [
        {
          id: 'pending',
          name: 'Pending',
        },
        {
          id: 'approved',
          name: 'Approved',
        },
        {
          id: 'rejected',
          name: 'Rejected',
        },
      ],
    },
  ],
  searchBarProp: 'complex_name',
};
